/**
 *
 * @description: 华宝基金
 *
 */
import { isBuild } from '@/apis/host';
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'hbjj';
const comein_channel = isBuild ? '879f0686-e5d4-419f-8030-675734024894' : 'a071014f-02b0-490f-b2f0-51538e2aeacf';

export const isThirdParty = isThirdPartyMode({ brmChannel, comein_channel });

if (isThirdParty) window.comeinChannel = 'hbjj';

// 华宝基金Bridge类 - 继承基类，可以重写或添加新方法
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, false);
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

export { Bridge };
